// extracted by mini-css-extract-plugin
export default {"valueCircle":"value-circle-module__valueCircle___ZVGQK"};